import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import { Switch } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ColumnBaseProps } from '../types';

const PivotScreenColumn: React.FC<ColumnBaseProps> = ({ record }) => {
  return (
    <Switch
      checkedChildren={<EyeFilled />}
      unCheckedChildren={<EyeInvisibleFilled />}
      onClick={record.formField.pivotScreenVisibilityToggleModel.toggle}
      checked={record.formField.pivotScreenVisibility}
      disabled={record.formField.pivotScreenVisibilityToggleModel.disabled}
    />
  );
};

export default observer(PivotScreenColumn);
